<template>
  <div class="personarize-progress-base">
    <canvas v-show="enable"></canvas>
  </div>
</template>

<script>
export default {
  name: "PersonarizeProgress",
  data(){
    return {
      enable: false,
      cnv: null,
      ctx: null,
      grad: null,
      baseGray: '#EFEFEF',
      duration: 8000, //秒数ではない
      mask: null,
      size: 0,
      center: 0,
      radius: 0,
      sep: 0,
      rad: 0,
      last: 0,
      lim: 0,
      offset: 0,
      noiseRad: 0,
      noiseAdd: 0
    }
  },
  props: {
    trigger: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  watch: {
    trigger(val){
      this.start()
    }
  },
  mounted() {
    this.resourseLoad()
  },
  methods: {
    resourseLoad(){
      this.mask = document.createElement('img')
      this.mask.src = '/static/img/common/loader_mask.svg'
    },
    initiarize(){
      this.duration = this.duration + (Math.random() * 3000)
      this.cnv = this.$el.querySelector('.personarize-progress-base canvas')
      this.size = this.$el.clientWidth * 2
      this.cnv.width = this.size
      this.cnv.height = this.size
      this.center = this.size / 2
      this.radius = Math.sqrt(this.size ** 2 * this.size ** 2)
      this.ctx = this.cnv.getContext('2d')
      this.grad = this.ctx.createLinearGradient(0,0,this.cnv.width, this.cnv.height)
      this.grad.addColorStop(0.1, 'rgb(255, 116, 151)')
      this.grad.addColorStop(0.8, 'rgb(203, 139, 255)')
      this.rad = 0
      this.lim = Math.PI * 2
      this.offset = - Math.PI / 2
      this.sep = this.lim / this.duration
      this.noiseAdd = 0.05
      this.ctx.fillStyle = this.baseGray
      this.ctx.fillRect(0, 0, this.cnv.width, this.cnv.height)
      this.enable = true
    },
    start(){
      this.initiarize()
      setTimeout(()=>{
        this.last = new Date().getTime()
        requestAnimationFrame(this.draw)
      },0)
    },
    draw(){
      const c = this.ctx
      const d = new Date().getTime()
      c.fillStyle = this.grad
      c.fillRect(0, 0, this.cnv.width, this.cnv.height)
      if(this.rad < this.lim){
        this.noiseRad += this.noiseAdd
        c.fillStyle = this.baseGray
        c.beginPath()
        c.moveTo(this.center, this.center)
        c.lineTo(this.center, this.center - this.radius)
        c.arc(this.center, this.center, this.radius, this.lim + this.offset, this.rad + this.offset, true)
        c.fill()
        const n = Math.sin(this.noiseRad)
        this.rad += !!d ? (d - this.last) * (this.sep + ( (n > 0 ? n : 0) * 0.002)) : 0
        requestAnimationFrame(this.draw)
      } else {
        this.complete()
      }
      this.last = d
    },
    complete() {
      this.$emit('complete')
    }
  }
}</script>

<style scoped lang="scss">
.personarize-progress-base{
  $size: 16.26vw;
  width: $size;
  height: $size;
  mask-image: url("/static/img/common/loader_mask.svg");
  mask-size: cover;
  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/PersonarizeProgress.vue